 document.addEventListener("DOMContentLoaded", function(){
    let giftIframe = document.querySelector("#giftbox-root > div > iframe")
    let toggleIframe = document.querySelector("#giftbox-root > div > iframe")
    console.log("cookie",sessionStorage.getItem('giftbox-first-visit'))
    let myTimeout
    if(!sessionStorage.getItem('giftbox-first-visit')){
      	console.log("start the timeout")
    	myTimeout = setInterval(checkForIframe, 100);
    }
  	const myToggleTimeout = setInterval(checkForToggleIframe, 100);
  
  	function checkForIframe(){
  		giftIframe = document.querySelector("#giftbox-root > div > div > iframe")
        toggleIframe = document.querySelector("#giftbox-root > div > iframe")
        if(giftIframe){
        	console.log("there it is", giftIframe)
            myStopFunction()
//             this is good so far
			setTimeout(renderCustomATC,200)
            
        }else{
        	console.log("gift iframe not loaded")
        }
  
  	}
                          
    function checkForToggleIframe(){
		toggleIframe = document.querySelector("#giftbox-root > div > iframe")
              if(toggleIframe){
        console.log("there it is", toggleIframe)
          myToggleStopFunction()
          toggleIframe.contentDocument.addEventListener("click", () =>{
                                                        if(sessionStorage.getItem('giftbox-first-visit')){
          
            console.log("clicked")
            setTimeout(grabTheSecondIframe,200)
              function grabTheSecondIframe(){
                console.log("second iframe", sessionStorage.getItem('giftbox-first-visit'))
                
                        renderCustomATC()
                    }
                  
              }
    })

      }else{
        console.log("toggle iframe not loaded")
      }
	}
    
    function renderCustomATC(){
   
  giftIframe = document.querySelector("#giftbox-root > div > div > iframe")
//             console.log("iframeDocument",giftIframe.contentWindow.document)
            const iframeBody = giftIframe.contentDocument.querySelector("body")
//             console.log("iframeBody",iframeBody)
            console.log( iframeBody.querySelector(".frame-content"))
                    
            var head = giftIframe.contentWindow.document.getElementsByTagName('head')[0];
          var script = giftIframe.contentWindow.document.createElement('script');
          script.innerText = `function atc(){
            const event = new Event('giftATC');
            document.querySelector("body").dispatchEvent(event);
            }`;
          script.type = 'text/javascript';
          head.appendChild(script);
/*
          iframeBody.insertAdjacentHTML("beforeend", `
            <style>
.GiftBox-Header h1{
font-size: 1.3em;
padding-left: 10px;
text-align: left;
}
            #gift-cta{
            font-weight: 600;
            font-size: 15px;
            }
            #giftATC{
            display: flex;
            justify-content: space-between;
            padding-left: 16px;
            height: 60px;
            align-items: center;
            padding-right: 16px;
            }
#gift-atc{
width: 30px;
height: 30px;
color: white;
border:none;
background: #98705b;
border-radius: 100px;
padding:0;
transition: .2s;
cursor: pointer;
}
#gift-atc:hover{
background: #bb8b72;
}
.svg-circleplus { height: 30px; stroke: white; }
            </style>
            <div id='giftATC'>
            <p  id='gift-cta'>Køb Marts-pakken</p>
            <button  id='gift-atc' onclick="atc()"> 
              <svg class="svg-circleplus" viewBox="0 0 100 100">
                <line x1="32.5" y1="50" x2="67.5" y2="50" stroke-width="5"></line>
                <line x1="50" y1="32.5" x2="50" y2="67.5" stroke-width="5"></line>
          	  </svg>
			</button>
            </div>
<form method="post" action="/cart/add">
      <input type="hidden" name="id" value="{{ product.variants.first.id }}" />
       

    </form>
            <script>
            function atc() {
            console.log('atc')
            }
            </script>
		  `)
                    
                    iframeBody.addEventListener("giftATC", ()=>{
						console.log("custom event fired")
                    jQuery.post('/cart/add.js', {
                      items: [
                        {
                          quantity: 1,
                          id: 42556782936298
                        }
                      ]
                    });
                                                	}) 
                   
                
		*/	
        }
                          

  	function myStopFunction() {
      clearTimeout(myTimeout);
	}

	function myToggleStopFunction() {
      clearTimeout(myToggleTimeout);
	}
	
});

